const engagementTrackingAction = 'product rec engagement';
$(document).ready(function(){
    $(window).on('carouselChange', function(e) {
        handleCarouselEngagement(e);
    });
    $(window).on('beforeunload', function() {
        endEngagement();
    });
    $(document).on('click', 'li.slick-slide', function() {
        const activeCarousel = $(this).closest("div.carousel");
        if(activeCarousel.hasClass("eng-tracking-on")){
            activeCarousel.removeClass("eng-tracking-on");
            const data = {
                leftclick: activeCarousel.data("eng-left-click"),
                rightclick: activeCarousel.data("eng-right-click"),
                slideclick: $(this).data('slick-index') + 1,
            }
            logEngagementWithDetails(window.location.href, activeCarousel.data("type"), engagementTrackingAction , JSON.stringify(data));
            activeCarousel.unbind('mouseleave');
        } else {
            if($('div.eng-tracking-on').length){ // slide clicked of the carousal which was not currently being tracked, so end tracking of the tracked carousal first.
                endEngagement();
            }
            const type = $($(this).closest('div[data-type]')).attr('data-type');
            const data = {
                leftclick: 0,
                rightclick: 0,
                slideclick: $(this).data('slick-index') + 1 ,
            }
            logEngagementWithDetails(window.location.href, type, engagementTrackingAction, JSON.stringify(data));
        }
        clearTimeout(window.carouselEngagementTracker);
        window.carouselEngagementTracker = null;
    });
});
 function endEngagement() {
     clearTimeout(window.carouselEngagementTracker);
     const activeCarousel = $('div.eng-tracking-on');
     if(typeof activeCarousel!== "undefined" && activeCarousel.length) {
         activeCarousel.removeClass('eng-tracking-on');
         const data = {
             leftclick: activeCarousel.data('eng-left-click'),
             rightclick: activeCarousel.data('eng-right-click'),
         }
         activeCarousel.unbind('mouseleave');
         if (typeof activeCarousel.data("pageUrl") !== "undefined" && activeCarousel.data("pageUrl") !== ""
             && typeof activeCarousel.data("type") !== "undefined" && activeCarousel.data("type") !== "") {
             logEngagementWithDetails(activeCarousel.data("pageUrl"), activeCarousel.data("type"), engagementTrackingAction, JSON.stringify(data));
         }
     }
 }
function handleCarouselEngagement(e) {
    let startEngagement = function () {
        const activeCarousel = $(e.originalEvent.tracking.element).closest("div.carousel");
        activeCarousel.addClass("eng-tracking-on");
        activeCarousel.data("pageUrl", e.originalEvent.tracking.pageUrl);
        activeCarousel.data("type", e.originalEvent.tracking.type);
        activeCarousel.data("eng-left-click", 0);
        activeCarousel.data("eng-right-click", 1);
        activeCarousel.data("currentSlide", e.originalEvent.tracking.currentSlide);
        activeCarousel.mouseleave(function () {
            clearTimeout(window.carouselEngagementTracker);
            window.carouselEngagementTracker = null;
            window.carouselEngagementTracker = setTimeout(function () {
                endEngagement();
            }, 3000);
        });
    };

    let resetEngagement = function(){
        endEngagement();
        startEngagement();
    };
    let continueEngagement = function() {
        const activeCarousel = $('div.eng-tracking-on');
        clearTimeout(window.carouselEngagementTracker);
        window.carouselEngagementTracker = null;
        if (activeCarousel.data("currentSlide") < e.originalEvent.tracking.currentSlide) {
            activeCarousel.data('eng-right-click', activeCarousel.data('eng-right-click') + 1);
        } else {
            activeCarousel.data('eng-left-click', activeCarousel.data('eng-left-click') + 1);
        }
        activeCarousel.data("currentSlide", e.originalEvent.tracking.currentSlide);
    };

    if($('div.eng-tracking-on').length) {
        const activeCarousel = $(e.originalEvent.tracking.element).closest('div.carousel');
        if(activeCarousel.hasClass('eng-tracking-on')){
            continueEngagement();
        } else {
            resetEngagement();
        }
    } else {
        startEngagement();
    }
}


// WEBPACK FOOTER //
// ./src/scripts/modules/product-rec-tracking.js